import { Placement } from '@floating-ui/react';
import { Property } from 'csstype';
import { ReactNode, useState } from 'react';

import { ChevronDownIcon, Popover } from '../../index';
import { addStyles } from '../../utils/helpers';

type Theme = 'light' | 'dark' | 'primary';

export type DropdownMenuProps = {
  // Content for clicking on to open/close menu
  buttonContent: ReactNode;
  // Content shown in dropdown menu
  menuContent: ReactNode;
  // The icon to use
  menuIcon?: ReactNode;
  // Menu content width
  width?: Property.Width;
  // Allow menu to be open by default
  defaultOpen?: boolean;
  // Control color theme
  theme?: Theme;
  // Controll render position of menu
  position?: Placement;
  // Close menu on user select
  closeOnSelect?: boolean;
};

const DefaultMenuIcon = (theme: Theme) => (
  <ChevronDownIcon
    className={`ml-2 h-auto w-6 ${theme === 'dark' && 'fill-white'} ${theme === 'primary' && 'fill-primary'}`}
  />
);

export const DropdownMenu = (props: DropdownMenuProps) => {
  const {
    menuIcon,
    menuContent,
    buttonContent,
    width = 'max-content',
    defaultOpen = false,
    theme = 'light',
    position = 'bottom-start',
    closeOnSelect = false,
  } = props;
  const [visible, setVisible] = useState<boolean>(defaultOpen);

  const iconToUse = menuIcon ?? DefaultMenuIcon(theme);

  return (
    <Popover
      open={visible}
      showArrow={false}
      trigger="click"
      placement={position}
      innerContentClassName=""
      autoPlacementOptions={{ allowedPlacements: ['top', 'bottom'] }}
      onOpenChange={(isOpen: boolean) => {
        setVisible(isOpen);
      }}
      content={
        <div
          style={{ width }}
          onClick={() => {
            if (closeOnSelect) {
              setVisible(false);
            }
          }}
        >
          {menuContent}
        </div>
      }
    >
      <div
        className={addStyles([
          'inline-flex justify-between items-center hover:cursor-pointer',
          theme === 'dark' ? 'text-white' : undefined,
        ])}
      >
        <span className={`${theme === 'primary' && 'text-primary'}`}>{buttonContent}</span>
        {iconToUse}
      </div>
    </Popover>
  );
};
export default DropdownMenu;
